import React from "react";
import Element from '../element';
import './footer.scss';

export default class Footer extends React.Component {
    static defaultProps = {
        actions: [],
        align: 'center', // left, center, right
    }

    render() {
        const actions = this.props.actions.map((i, index) => {
            return <Element key={index} className='action btn btn-primary btn-lg-wide' data={i} />
        });

        const actionsClassName = ('actions ' + (this.props.align || '')).trim();
        
        return (
            <div className='footer'>
                <div className='container'>
                    <div className={actionsClassName}>
                        {this.props.beforeActions}
                        {actions}
                        {this.props.afterActions}
                    </div>
                </div>
            </div>
        );
    }
}